var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-title',{staticClass:"text-h3"},[_vm._v("TVOS-PMS")])}
var staticRenderFns = []

export { render, staticRenderFns }